import { init, RematchDispatch, RematchRootState, Plugin } from '@rematch/core';
import selectPlugin from '@rematch/select';
import createRematchPersist, { getPersistor } from '@rematch/persist';
import storage from 'redux-persist/lib/storage';
import { History, createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';

import { models, RootModel } from '../models';

const metaVersion = document.head.querySelector('[name~=sversion][content]');
const persistPlugin = createRematchPersist({
  key: 'root',
  storage,
  version: parseFloat(process.env.REACT_APP_GIT_TAG || metaVersion?.getAttribute('content') || '1'),
  whitelist: ['odds', 'betslip']
}) as Plugin<RootModel>;
export const history: History = createBrowserHistory();

export const store = init<RootModel>({
  redux: {
    reducers: {
      router: connectRouter(history)
    },
    middlewares: [routerMiddleware(history)],
    devtoolOptions: {
      disabled: process.env.REACT_APP_ENV !== 'local' && process.env.REACT_APP_ENV !== 'develop'
    }
  },
  models,
  plugins: [
    persistPlugin,
    selectPlugin()
  ]
});

export const { select } = store;
export const persistor = getPersistor();
export default store;

export type Store = typeof store
export type Dispatch = RematchDispatch<RootModel>
export type RootState = RematchRootState<RootModel>
